import { render, staticRenderFns } from "./travel-insurance-form-step-2.vue?vue&type=template&id=a8e2c306&scoped=true"
import script from "./travel-insurance-form-step-2.vue?vue&type=script&setup=true&lang=ts"
export * from "./travel-insurance-form-step-2.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./travel-insurance-form-step-2.vue?vue&type=style&index=0&id=a8e2c306&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8e2c306",
  null
  
)

export default component.exports